import type { GlowColor } from "./_types";

export const text_motion = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

export const social_link_motion = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};

export const hero_glow_motion = {
  hidden: { 
    opacity: 0.2 
  },
  visible: {
    opacity: [0.18, 0.22, 0.25, 0.27, 0.25, 0.21, 0.17],
  },
};

export const glow_style: Record<GlowColor, string> = {
  purple: "from-purple-400 to-violet-500/95",
  sky: "from-sky-400 to-indigo-400/90",
};
